import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewTournamentStat = (params) => {
    return axios.get(`${backendHost}/api/admin/tournament-stat/view`, {params});
};

export {
    getViewTournamentStat
}